import { render, staticRenderFns } from "./HormonalHistoryTemplate.vue?vue&type=template&id=383804f2&scoped=true"
import script from "./HormonalHistoryTemplate.vue?vue&type=script&lang=js"
export * from "./HormonalHistoryTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383804f2",
  null
  
)

export default component.exports